import { useEffect, useState } from 'react';

import { createPortal } from 'react-dom';

import { dismissToast, subscribeToasts } from './toastStore';
import './styles.scss';

/**
 * App-level toast viewport. Mount once near the app root.
 */
const ToastHost = () => {
    const [toasts, setToasts] = useState([]);

    useEffect(() => subscribeToasts(setToasts), []);

    if (typeof document === 'undefined') {
        return null;
    }

    return createPortal(
        <div
            className='app-toast-host'
            aria-live='polite'
            aria-relevant='additions'>
            {toasts.map((toast) => (
                <div
                    key={toast.id}
                    className={[
                        'app-toast',
                        `app-toast--${toast.variant}`,
                        `app-toast--${toast.position}`,
                        toast.icon ? null : 'app-toast--no-icon',
                    ]
                        .filter(Boolean)
                        .join(' ')}
                    role='status'
                    onClick={() => dismissToast(toast.id)}>
                    {toast.icon ? (
                        <img
                            className='app-toast__icon'
                            src={toast.icon}
                            alt={toast.variant}
                        />
                    ) : null}
                    <p className='app-toast__message'>{toast.message}</p>
                </div>
            ))}
        </div>,
        document.body
    );
};

export default ToastHost;
